import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const gettoken = localStorage.getItem("authToken");

  if (gettoken && gettoken !== "null") {
    // If token exists, redirect to home
    return <Navigate to="/home" replace />;
  }

  // If no token, render the login page
  return children;
};

export default PublicRoute;
